import { Table as TanStackTable } from '@tanstack/react-table';
import { createContext, useContext } from 'react';

const TableContext = createContext<TanStackTable<any> | null>(null);

export const TableProvider = TableContext.Provider;

export function useTableContext<T = any>(): TanStackTable<T> {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error('Table components must be used within Table.Root');
  }
  return context as TanStackTable<T>;
}
